import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "form-container" }

import ATabs from '@/components/atoms/ATabs.vue'
	import MDynamicForm from '@/components/molecules/MDynamicForm.vue'
	import MOptionalsForm from '@/components/molecules/MOptionalsForm.vue'
	import MDocumentation from '@/components/molecules/MDocumentation.vue'
	import AgDatatable from '@/components/datatable/AgDatatable.vue'
	import PersonPicture from './components/PersonPicture.vue'
	import DefaultCellRenderer from '@/components/datatable/cellRenderers/DefaultCellRenderer.vue'

	import type { ObjectContext } from '@/global'
	import type { ComputedRef } from 'vue'

	import { ref, reactive, computed, watch } from 'vue'
	import { useGeneral } from '@/hooks'

	
export default /*#__PURE__*/_defineComponent({
  props: {
		item: { type: Object, default: null, required: true }
	},
  setup(__props) {

const $props = __props

	const { $t, $moment, $store, $router, $route, isNew, tabSelected, mainClick, loading } = useGeneral()

	

	const state = reactive({
		tab: 'information',
		item: {},
		optionals: [],
		optionalsToDelete: []
	})

	const formTitleKey: ComputedRef<string> = computed(() => $store.getters['forms/GET_FORM_TITLE_KEYS'][tabSelected.value] || 'General_title')
	// @ts-ignore
	const titleValue = computed(() => state.item[formTitleKey.value])
	function updateTitle() {
		$store.dispatch('forms/setFormTitle', titleValue.value || '')
	}
	watch(
		() => titleValue.value,
		() => updateTitle()
	)

	const tabItems: Array<ObjectContext> = [
		{ text: 'General_information', value: 'information', disabled: false },
		{ text: 'PersonsDialog_tab_history', value: 'history', disabled: isNew.value },
		{ text: 'General_documentation', value: 'documentation', disabled: isNew.value }
	]

	function changeTab(event: string) {
		state.tab = event
	}

	const invisibleKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_INVISIBLE'][tabSelected.value] || {}))
	const requiredKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_REQUIRED'][tabSelected.value] || {}))
	const formHiddenKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_FORM_HIDDEN'][tabSelected.value] || {}))
	const datetimeKeys: ComputedRef = computed(() => Object.values($store.getters['dictionary/GET_DATETIME'][tabSelected.value] || {}))

	const sections: ComputedRef = computed(() => {
		const table = !isNew.value
		const inputs = {
			information: [
				{ id: 'required_information', title: 'Form_step_required', keys: requiredKeys.value, table },
				{ id: 'credentials_information', title: 'Form_step_credentials', keys: ['can_login', 'email', 'password', 'role_id'], table },
				{ id: 'personal_information', title: 'Form_step_personal', keys: ['person_national_id', 'phone_prefix', 'phone_number'], table },
				{ id: 'labor_information', title: 'Form_step_labor', keys: ['person_label_id', 'group_ids', 'default_group_id'], table },
				{ id: 'optional_information', title: 'Form_step_optional' }
			]
		}
		// @ts-ignore
		return inputs[state.tab] || []
	})

	const sectionKeys = computed(() => {
		let items: Array<string> = ['can_work']
		// @ts-ignore
		sections.value.forEach(e => (items = items.concat(e.keys || [])))
		return items
	})

	function deleteKey(key: string) {
		// @ts-ignore
		if (key && !state.optionalsToDelete.includes(key)) state.optionalsToDelete.push(key)
	}
	function updateOptionals(items: Array<ObjectContext>) {
		state.optionals = JSON.parse(JSON.stringify(items))
	}

	watch(
		() => $props.item,
		(val: any) => {
			const item = Object.assign({}, val || {})
			const keys = invisibleKeys.value.concat(requiredKeys.value).concat(formHiddenKeys.value)
			keys.forEach((key: string) => delete item[key])
			const optionals = Object.keys(item).map(key => {
				return { key, value: item[key] }
			})
			// @ts-ignore
			state.optionals = optionals
			state.item = Object.assign({}, val || {})
		}
	)

	// @ts-ignore
	const historyItems = computed(() => state.item?.records_summary || [])
	const historyKeys = ['worked_hours_str', 'person_record_at']
	const historyHeaders = historyKeys.map(e => {
		return {
			headerName: e,
			field: e,
			resizable: true,
			sortable: false,
			editable: false,
			cellRenderer: DefaultCellRenderer
		}
	})

	const refForm = ref(null)

	async function onSaveItem() {
		// @ts-ignore
		const res = await refForm.value.validate()
		const isValid = res.valid
		if (isValid) {
			const action = isNew.value ? 'create' : 'update'
			const tab = tabSelected.value
			try {
				const body = {
					...state.item
				}
				// @ts-ignore
				if (!isNew.value) body._item = state.item
				const keys = invisibleKeys.value.concat(formHiddenKeys.value)
				// @ts-ignore
				keys.forEach((key: string) => delete body[key])
				// @ts-ignore
				state.optionalsToDelete.forEach(key => (body[key] = null))
				// @ts-ignore
				state.optionals.forEach(e => (body[e.key] = e.value))
				Object.keys(body).forEach(key => {
					if (datetimeKeys.value.includes(key)) {
						// @ts-ignore
						body[key] = $moment(body[key]).format()
					}
				})
				await $store.dispatch(`${tab}/${action}`, body)
				const routeName = $route.name.replace('_edit', '')
				$router.push({ name: routeName, params: { tab } })
			} catch (error) {
				console.log(`🚀 ~ onSaveItem ~ error`, error)
				$store.dispatch('alert/SET_ALERT', { action, error })
			}
		}
	}

	watch(mainClick, () => onSaveItem())

	function init() {
		$store.dispatch('forms/initSteps', { tabSelected: tabSelected.value })
	}
	init()

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_row, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: "12",
          class: "mb-7"
        }, {
          default: _withCtx(() => [
            (_unref(loading))
              ? (_openBlock(), _createBlock(_component_v_skeleton_loader, {
                  key: 0,
                  type: "text"
                }))
              : (_openBlock(), _createBlock(ATabs, {
                  key: 1,
                  modelValue: _unref(state).tab,
                  items: tabItems,
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (changeTab($event)))
                }, null, 8, ["modelValue"]))
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_form, {
      ref_key: "refForm",
      ref: refForm
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window, {
          modelValue: _unref(state).tab,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).tab) = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_window_item, { value: "information" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      cols: "4",
                      xl: "3"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(PersonPicture, {
                          item: $props.item
                        }, null, 8, ["item"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, {
                      cols: "8",
                      xl: "9"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_1, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(sections), (section) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: section.id
                            }, [
                              (section.id === 'optional_information' ? _unref(state).optionals.length : true)
                                ? (_openBlock(), _createBlock(_component_v_col, {
                                    key: 0,
                                    cols: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(_unref($t)(section.title)) + " ", 1),
                                      _createVNode(_component_v_divider, {
                                        color: "primary_alt",
                                        class: "mt-4"
                                      })
                                    ]),
                                    _: 2
                                  }, 1024))
                                : _createCommentVNode("", true),
                              _createVNode(_component_v_col, { cols: "12" }, {
                                default: _withCtx(() => [
                                  (section.id === 'optional_information')
                                    ? (_openBlock(), _createBlock(MOptionalsForm, {
                                        key: 0,
                                        modelValue: _unref(state).optionals,
                                        "keys-to-avoid": _unref(sectionKeys),
                                        "tab-selected": _unref(tabSelected),
                                        item: _unref(state).item,
                                        onDeleteKey: _cache[1] || (_cache[1] = ($event: any) => (deleteKey($event))),
                                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (updateOptionals($event)))
                                      }, null, 8, ["modelValue", "keys-to-avoid", "tab-selected", "item"]))
                                    : (_openBlock(), _createBlock(MDynamicForm, {
                                        key: 1,
                                        modelValue: _unref(state).item,
                                        table: section.table,
                                        keys: section.keys,
                                        "tab-selected": _unref(tabSelected),
                                        cols: 4,
                                        xl: 3
                                      }, null, 8, ["modelValue", "table", "keys", "tab-selected"]))
                                ]),
                                _: 2
                              }, 1024)
                            ], 64))
                          }), 128))
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "history" }, {
              default: _withCtx(() => [
                _createVNode(AgDatatable, {
                  headers: _unref(historyHeaders),
                  items: _unref(historyItems),
                  "auto-height": ""
                }, null, 8, ["headers", "items"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_window_item, { value: "documentation" }, {
              default: _withCtx(() => [
                (_unref(state).tab === 'documentation')
                  ? (_openBlock(), _createBlock(MDocumentation, {
                      key: 0,
                      item: _unref(state).item,
                      "tab-selected": _unref(tabSelected)
                    }, null, 8, ["item", "tab-selected"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})